module.exports = __webpack_public_path__ + "static/video6-ecef5e15627fae5fd03ad1485c6827a8.mp4";